import { render } from "./PublicDashboardView.vue?vue&type=template&id=ef18ca50"
import script from "./PublicDashboardView.vue?vue&type=script&lang=js"
export * from "./PublicDashboardView.vue?vue&type=script&lang=js"

import "./PublicDashboardView.vue?vue&type=style&index=0&id=ef18ca50&lang=css"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__